<template>
    <div class="contact-us-section pb-70">

        <div class="container">
            <div class="row">
                <div class="col-md-2"></div>
                <div class="col-md-8 text-center">
                    <div class="sec-title">
                        <h2>Ihre Nachricht an uns</h2>
                        <p></p>
                    </div>
                </div>
                <div class="col-md-2"></div>
            </div>
        </div>

        <div :class="isMobile() ? 'mb-20' : 'contact-form'">
            <form class="m-20" v-on:submit.prevent="register">
                <input-component label="Name"
                                 placeholder="Name"
                                 id="name"
                                 name="name"
                                 type="text"
                                 :is-required="true"
                                 v-model="user.name"
                                 v-validate.initial="'required'">
                </input-component>
                <input-component label="Vorname"
                                 placeholder="Vorname"
                                 id="vorname"
                                 name="vorname"
                                 type="text"
                                 :is-required="true"
                                 v-model="user.surname"
                                 v-validate.initial="'required'">
                </input-component>
                <input-component label="Phone"
                                 placeholder="Phone"
                                 id="phone"
                                 name="phone"
                                 type="tel"
                                 :is-required="true"
                                 v-model="user.phone"
                                 v-validate.initial="'required'">
                </input-component>
                <input-component label="Email"
                                 placeholder="Email"
                                 id="email"
                                 name="email"
                                 type="email"
                                 :is-required="true"
                                 v-model="user.email"
                                 v-validate.initial="'required'">
                </input-component>
                <textarea class="form-control" placeholder="Nachricht*" name="description" id="description"
                          v-model="user.short_description" rows="7"></textarea>
                <vue-recaptcha class="mt-15" sitekey="6Ld9prQUAAAAALMKGjs8KUHsB8_rZ8hgVw0Dk2yi"
                               :loadRecaptchaScript="true"
                               @expired="expired"
                               @verify="verified"/>
                <div v-if="error || success">
                    <span :class="!!error ? 'cal-text-error' : 'cal-text-success'">{{error ? error : success}}</span>
                </div>
                <button type="submit" class="btn cal-btn-primary mt-15" :class="isMobile() ? '' : 'pull-right'"
                >
                    Nachricth Senden
                </button>
            </form>
        </div>

        <l-map :style="{width: '100%', height: isMobile() ? '250px' : '600px'}" :zoom="zoom" :center="center">
            <l-tile-layer :url="url"></l-tile-layer>
            <l-marker :lat-lng="markerLatLng"></l-marker>
        </l-map>

    </div>
</template>

<script>
    import InputComponent from './Input';
    import VueRecaptcha from 'vue-recaptcha';
    import ApiFactory from './ApiFactory';

    const lat = 41.328922;
    const lng = 19.8152005;

    export default {
        name: 'ContactUs',
        components: {
            InputComponent,
            VueRecaptcha,
        },
        data () {
            return {
                url: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
                zoom: 18,
                center: [lat, lng],
                markerLatLng: [lat, lng],
                user: {},
                error: null,
                success: null,
                captcha: false
            };
        },
        mounted () {
            this.renderCenter();
            window.addEventListener('resize', this.renderCenter);
        },
        methods: {
            renderCenter () {
                if (this.isMobile()) {
                    this.center = this.markerLatLng;
                } else {
                    const offset = window.innerWidth - 340;
                    const lngOffset = offset / 1000000;
                    this.center = [lat, lng + lngOffset];
                }
            },
            isMobile () {
                return window.innerWidth < 768;
            },
            verified (response) {
                this.captcha = !!response;
            },
            expired () {
                this.captcha = false;
            },
            register () {
                const vm = this;
                ApiFactory.post('lamaj/register', vm.user).then(() => {
                    vm.user = {};
                    this.success = 'Thank you for contacting us. We successfully received your request and will get back at you as soon as possible.';
                    this.error = null;
                }, () => {
                    this.error = 'Unexpected error occurred, please try again!';
                    this.success = null;
                });
            }
        }
    };
</script>
